import React from "react"
import { ActionMeta, Props } from "react-select"
import { SelectField } from "../fields/SelectField"
import { useController, useFormContext } from "react-hook-form"

type OwnProps = {
  label?: string
  helperText?: string
  name: string
  onChange?: (value: any) => void
  options: { label: string; value: string | number }[]
} & Props

export const SelectInput = ({ name, onChange, options, ...rest }: OwnProps) => {
  const { control, formState, getFieldState } = useFormContext()

  const {
    field: { ref, value, onChange: controllerOnChange, ...controllerRest },
  } = useController({
    name: name as string,
    control,
  })

  const customOnChange = (value: unknown, actionMeta: ActionMeta<unknown>) => {
    const newValue = value as { value: string; label: string }
    controllerOnChange(newValue.value, actionMeta)
    if (onChange) {
      onChange(newValue.value)
    }
  }

  return (
    <SelectField
      innerRef={ref}
      errorMessage={getFieldState(name as string, formState).error?.message}
      onChange={customOnChange}
      value={options?.find((option) => option.value === value)}
      options={options}
      {...rest}
      {...controllerRest}
    />
  )
}
